import { connect } from "react-redux";
import Widget from "./widget";
import {
  removeWidgetFromLayout,
  editWidget
} from "../../actions/layoutActions";
import type { AppDispatch, RootState } from "../../store";

const mapStateToProps = (state: RootState) => {
  const { isLayoutLocked, editWidgetIdentifiers } = state.layouts;

  return {
    isLayoutLocked,
    editWidgetIdentifiers
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    removeWidgetFromLayout: (widget_id: string) => {
      dispatch(removeWidgetFromLayout(widget_id));
    },
    editWidget: (widget_id: string) => {
      dispatch(editWidget(widget_id));
    }
  };
};

const WidgetContainer = connect(mapStateToProps, mapDispatchToProps)(Widget);

export default WidgetContainer;
